import { render, staticRenderFns } from "./pnl.vue?vue&type=template&id=722bbd28"
import script from "./pnl.vue?vue&type=script&lang=js"
export * from "./pnl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports